import { createStyledBreakpointsTheme } from 'styled-breakpoints'

export const getPrimaryTheme = (colorMode: 'light' | 'dark', tenant: Tenant) =>
  ({
    colorMode: colorMode,
    backgroundColor: colorMode === 'light' ? '#ffffff' : '#121212',
    backgroundColorInverted: colorMode === 'dark' ? '#ffffff' : '#222426',
    textColor: colorMode === 'light' ? '#202346' : '#ffffff',
    textColorInverted: colorMode === 'dark' ? '#202346' : '#ffffff',
    greyLight: colorMode === 'light' ? '#e9ebef' : '#454648',
    greyDark: colorMode === 'light' ? '#9298aa' : '#787b7e',
    mainColor: colorMode === 'light' ? '255, 126, 98' : '255, 126, 98',
    tenantColor:
      colorMode === 'light'
        ? tenant.key === '24heures'
          ? '#d9000b'
          : tenant.key === 'tdg'
          ? '#2c3890'
          : '#0a79bd'
        : '#ffffff',
  } as const)

export const getTheme = (colorMode: 'light' | 'dark', tenant: Tenant) => ({
  ...getPrimaryTheme(colorMode, tenant),
  ...createStyledBreakpointsTheme({
    breakpoints: {
      xs: '0px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
      xxl: '1400px',
      xxxl: '1580px',
    },
  }),
})
